if (!customElements.get('media-gallery')) {
  class MediaGallery extends HTMLElement {
    constructor(el) {
      super();

      const scope = el || this;

      this.elements = {
        liveRegion: scope.querySelector('[id^="GalleryStatus"]'),
        viewer: scope.querySelector('[id^="GalleryViewer"]'),
        thumbnails: scope.querySelector('[id^="GalleryThumbnails"]')
      };

      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails || !this.elements.viewer) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', () => {
          const mediaId = mediaToSwitch.dataset.target;
          document.documentElement.dataset.activeMediaId = mediaId;
          this.setActiveMedia(mediaId, false);
        });
      });

      if (scope.dataset.desktopLayout !== 'stacked' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails?.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer?.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        const activeThumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
        activeThumbnail?.parentElement?.prepend(activeThumbnail);
        if (this.elements.viewer.slider) this.elements.viewer.resetPages?.();
      }

      this.preventStickyHeader();

      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement?.scrollTo({ left: activeMedia.offsetLeft });
        } else if (this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({ behavior: 'smooth' });
        }
      });

      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail?.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;
      this.elements.thumbnails.querySelectorAll('button').forEach((element) => {
        element.removeAttribute('aria-current');
      });
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible?.(thumbnail, 10)) return;
      this.elements.thumbnails.slider?.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src; // retrigger load
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia?.();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent?.(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      this.stickyHeader?.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems?.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  }

  customElements.define('media-gallery', MediaGallery);

  // Re-initialize gallery inside modal when it opens
  document.querySelectorAll('product-modal').forEach(modal => {
    modal.addEventListener('open', () => {
      const modalGallery = modal.querySelector('media-gallery');
      if (modalGallery && !modalGallery.classList.contains('initialized')) {
        new MediaGallery(modalGallery);
        modalGallery.classList.add('initialized');
      }

      const activeMediaId = document.documentElement.dataset.activeMediaId;
      if (activeMediaId && modalGallery) {
        const media = modalGallery.querySelector(`[data-media-id="${activeMediaId}"]`);
        if (media) {
          media.scrollIntoView({ behavior: 'smooth', inline: 'center' });
        }
        document.documentElement.dataset.activeMediaId = '';
      }
    });
  });
}
